<template>
    <div v-if="isLoading" class="loader-overlay">
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            isLoading: {type: Boolean, required: true}, 
            refCount: {type: Number}          
        },
}
</script>
<style>
     
</style>

